import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Link as ScLink } from 'react-scroll';
import Link from './Link';
import Hamburger from './Hamburger';
import ContactInfo from './ContactInfo';
import styles from './Drawer.module.css';

class Drawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  toggleDrawer = () => this.setState({ open: !this.state.open });

  render() {
    const { className, links, logo, company, scrolled } = this.props;
    const { open } = this.state;
    const showBar = open || !scrolled;
    return (
      <div className={`${className} ${styles.wrapper}`} style={{ backgroundColor: showBar ? 'transparent' : 'hsla(0, 0%, 100%, 0.8)' }}>
        <Hamburger
          toggle={this.toggleDrawer}
          toggled={this.state.open}
        />
        <div className={styles.imgWrapper} style={{ opacity: showBar ? 0 : 1 }}>
          {logo}
        </div>
        <SwipeableDrawer
          anchor="bottom"
          classes={{ modal: styles.modal }}
          open={this.state.open}
          onClick={this.toggleDrawer}
          onClose={this.toggleDrawer}
          onOpen={this.toggleDrawer}
        >
          {logo}
          {links.map(({ name, active, onClick, el, ...rest }) => (
            <ScLink spy smooth to={el} key={name} {...rest} onClick={this.toggleDrawer}>
              <Link tag="h4" name={name} active={active} onClick={() => onClick && onClick()} />
            </ScLink>
          ))}
          <ContactInfo className={styles.contact} company={company} />
        </SwipeableDrawer>
      </div>
    );
  }
}

Drawer.propTypes = {
  scrolled: PropTypes.bool.isRequired,
  logo: PropTypes.node.isRequired,
  links: PropTypes.arrayOf(PropTypes.any),
  company: PropTypes.shape({
    addressFields: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.string,
    name: PropTypes.string,
    ceo: PropTypes.string,
    mobile: PropTypes.string,
    mail: PropTypes.string,
    phone: PropTypes.string,
    coordinates: PropTypes.shape({ lat: PropTypes.number.isRequired, lon: PropTypes.number.isRequired }),
  }).isRequired,
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/components/Drawer.js